import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, HeartIcon, StethoscopeIcon, ArrowRightIcon, ShieldIcon, LeafIcon, HandHeart } from 'lucide-react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
const features = ['Pago 100% seguro', 'Recibo inmediato por email', 'Puedes elegir el monto'];
function FeatureItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-2" data-id="element-284" data-mp="2br4ko8jfsi2h">
      <span style={{
      color: '#7DC920',
      fontWeight: 700
    }} data-id="element-285" data-mp="2bq36hv74jfgj">
        ✓
      </span>
      <span data-id="element-286" data-mp="2211sgak53857">{text}</span>
    </li>;
}
const impactItems = [{
  icon: BookOpenIcon,
  title: 'Educación',
  text: 'Recursos y guías para familias'
}, {
  icon: HeartIcon,
  title: 'Nutrición',
  text: 'Planes antiinflamatorios'
}, {
  icon: StethoscopeIcon,
  title: 'Especialistas',
  text: 'Acceso a medicina biomédica'
}, {
  icon: HandHeart,
  title: 'Familias en crisis',
  text: 'Artículos de primera necesidad para familias afectadas por emergencias aprobadas por la junta directiva'
}];
export function Donar() {
  useDocumentMeta({
    title: 'Donar | Pancita Feliz Foundation',
    description: 'Tu donación transforma vidas. Apoya a Pancita Feliz Foundation y ayuda a familias con necesidades de neurodesarrollo.',
    path: '/donar'
  });
  return <main className="w-full" data-id="element-287" data-mp="2d2on459hben8">
      {/* Hero */}
      <section className="text-center" style={{
      background: 'linear-gradient(135deg, #1a3a0a 0%, #2d5a1b 100%)',
      padding: '80px 20px 60px',
      color: 'white'
    }} data-id="element-288" data-mp="2d153c4om6lgp">
        <img src="https://cdn.magicpatterns.com/uploads/wpdp43pGEjSRNDR3FLVv4Q/pancita_feliz.png" alt="Pancita Feliz Foundation" className="mp-donar-hero-logo" style={{
        height: 'auto',
        objectFit: 'contain',
        display: 'block',
        margin: '0 auto 32px auto',
        filter: 'brightness(0) invert(1)'
      }} data-id="element-289" data-mp="236limsr5n3x4" />
        <p style={{
        fontSize: '13px',
        color: '#a8e063',
        letterSpacing: '3px',
        fontWeight: 600,
        textTransform: 'uppercase',
        marginBottom: '12px'
      }} data-id="element-290" data-mp="3w14e93qlmnt1">
          Tu Donación Transforma Vidas
        </p>
        <h1 className="mp-donar-title" style={{
        fontWeight: 700,
        color: 'white',
        marginBottom: '16px'
      }} data-id="element-291" data-mp="nlb559ylkem0">
          Sé Parte del Cambio
        </h1>
        <p style={{
        fontSize: '18px',
        color: 'rgba(255,255,255,0.85)',
        maxWidth: '580px',
        margin: '0 auto 40px'
      }} data-id="element-292" data-mp="duq13705mhvp">
          Cada donación permite que una familia acceda a educación, nutrición y
          medicina biomédica que transforma el neurodesarrollo de sus hijos.
        </p>
      </section>

      {/* Donation cards */}
      <section className="mp-donar-body" style={{
      background: '#f8faf5',
      padding: '60px 20px'
    }} data-id="element-293" data-mp="19urr52afj23u">
        <h2 style={{
        fontSize: '22px',
        fontWeight: 700,
        textAlign: 'center',
        color: '#1a1a1a',
        marginBottom: '8px'
      }} data-id="element-294" data-mp="1dx4trhtvqjwe">
          Elige cómo quieres apoyar
        </h2>
        <p style={{
        fontSize: '14px',
        color: '#666',
        textAlign: 'center',
        marginBottom: '28px'
      }} data-id="element-295" data-mp="1srsw4n3zh27s">
          Con PayPal puedes configurar una donación única, mensual o anual
        </p>
        <div className="mp-donar-cards" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '24px',
        maxWidth: '700px',
        margin: '0 auto'
      }} data-id="element-296" data-mp="26jpisbmvujws">
          {/* Card 1: Stripe */}
          <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '40px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          borderTop: '4px solid #635BFF',
          textAlign: 'center'
        }} data-id="element-297" data-mp="3d9jxts710ppn">
            <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #635BFF 0%, #8B7FFF 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            boxShadow: '0 8px 24px rgba(99,91,255,0.35)'
          }} data-id="element-298" data-mp="3i0ii12v4y7y6">
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg" alt="Stripe" style={{
              width: '60px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }} data-id="element-299" data-mp="2zbvfar0flunr" />
            </div>
            <h2 style={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '8px'
          }} data-id="element-300" data-mp="r3gpsjad5qrd">
              Donar con Tarjeta
            </h2>
            <p style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '20px'
          }} data-id="element-301" data-mp="14tahd9d96p4s">
              Visa, Mastercard, American Express
            </p>
            <ul className="space-y-2" style={{
            fontSize: '14px',
            color: '#555',
            textAlign: 'left',
            marginBottom: '28px'
          }} data-id="element-302" data-mp="v3h6yboukg24">
              <FeatureItem text="Pago 100% seguro" data-id="element-303" data-mp="1sjobd5feey20" />
              <FeatureItem text="Procesado por Stripe" data-id="element-304" data-mp="1skfxzqr0plg5" />
              <FeatureItem text="Recibo inmediato por email" data-id="element-305" data-mp="22fdcryoson4b" />
              <FeatureItem text="Puedes elegir el monto" data-id="element-306" data-mp="22cr6019qabn5" />
            </ul>
            <a href="https://donate.stripe.com/3cI00j5XRdfJ2z9efU00002" target="_blank" rel="noopener noreferrer" className="mp-stripe-btn mp-donar-btn flex items-center justify-center gap-2" style={{
            background: '#635BFF',
            color: 'white',
            width: '100%',
            height: '52px',
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 700,
            border: 'none',
            cursor: 'pointer',
            textDecoration: 'none'
          }} data-id="element-307" data-mp="1xgtohrmqaz8s">
              Donar con Tarjeta
              <ArrowRightIcon className="mp-donar-arrow" size={18} data-id="element-308" data-mp="10ogen6lb1sa7" />
            </a>
          </div>

          {/* Card 2: PayPal */}
          <div style={{
          background: 'white',
          borderRadius: '20px',
          padding: '40px 32px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          borderTop: '4px solid #009cde',
          textAlign: 'center'
        }} data-id="element-309" data-mp="vsrjdfgbixjp">
            <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #009cde 0%, #003087 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            boxShadow: '0 8px 24px rgba(0,156,222,0.35)'
          }} data-id="element-310" data-mp="3had7a0tuhvxf">
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" style={{
              width: '60px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }} data-id="element-311" data-mp="32g8e9nvbstog" />
            </div>
            <h2 style={{
            fontSize: '22px',
            fontWeight: 700,
            color: '#1a1a1a',
            marginBottom: '8px'
          }} data-id="element-312" data-mp="ydaej63ymxot">
              Donar con PayPal
            </h2>
            <p style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '20px'
          }} data-id="element-313" data-mp="1ma6b6wp45rev">
              Única, mensual o anual — tú eliges
            </p>
            <ul className="space-y-2" style={{
            fontSize: '14px',
            color: '#555',
            textAlign: 'left',
            marginBottom: '28px'
          }} data-id="element-314" data-mp="1w094ky05d7dq">
              <FeatureItem text="Pago 100% seguro" data-id="element-315" data-mp="24yl2ll3cf7g7" />
              <FeatureItem text="Procesado por PayPal" data-id="element-316" data-mp="20zvht7fz6nmj" />
              <FeatureItem text="Recibo inmediato por email" data-id="element-317" data-mp="20x98p3dfs027" />
              <FeatureItem text="Donación única, mensual o anual" data-id="element-318" data-mp="2jnw5dadgddz0" />
            </ul>
            <a href="https://www.paypal.com/donate/?hosted_button_id=PTKZKH49EXUBG" target="_blank" rel="noopener noreferrer" className="mp-paypal-gold-btn mp-donar-btn" style={{
            background: '#FFC439',
            color: '#003087',
            fontWeight: 700,
            fontSize: '15px',
            padding: '14px 28px',
            borderRadius: '8px',
            border: 'none',
            width: '100%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            textDecoration: 'none'
          }} data-id="element-319" data-mp="2olei7bulcdca">
              Donar con PayPal
              <ArrowRightIcon className="mp-donar-arrow" size={18} data-id="element-320" data-mp="1mvskqap92a52" />
            </a>
            <p style={{
            fontSize: '12px',
            color: '#888',
            textAlign: 'center',
            marginTop: '8px'
          }} data-id="element-321" data-mp="1l96s5hp5ilig">
              PayPal te permite elegir donación única, mensual o anual al
              momento del pago
            </p>
          </div>
        </div>

        {/* Trust section */}
        <div style={{
        marginTop: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        flexWrap: 'wrap'
      }} data-id="element-322" data-mp="23zei0y3ubfgp">
          {[{
          icon: ShieldIcon,
          label: 'Pagos 100% seguros'
        }, {
          icon: LeafIcon,
          label: 'Fundación 501(c)(3) registrada — tu donación es deducible de impuestos'
        }, {
          icon: HeartIcon,
          label: 'Tu donación hace la diferencia'
        }].map(({
          icon: Icon,
          label
        }) => <span key={label} style={{
          fontSize: '13px',
          color: '#555',
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }} data-id="element-323" data-mp="bboui7kug1gz">
              <Icon size={16} color="#7DC920" data-id="element-324" data-mp="3tgs5g8xhr7pb" />
              {label}
            </span>)}
        </div>

        {/* Impact section */}
        <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '700px',
        margin: '40px auto 0',
        padding: '32px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.06)'
      }} data-id="element-325" data-mp="3oja351dzbqqa">
          <h3 style={{
          fontSize: '20px',
          fontWeight: 700,
          color: '#1a1a1a',
          textAlign: 'center',
          marginBottom: '24px'
        }} data-id="element-326" data-mp="1hqpvwssn1buy">
            ¿A dónde va tu donación?
          </h3>
          <div className="mp-donar-impact" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '20px',
          textAlign: 'center'
        }} data-id="element-327" data-mp="fduoqmt5i1fn">
            {impactItems.map(({
            icon: Icon,
            title,
            text
          }) => <div key={title} className="flex flex-col items-center" data-id="element-328" data-mp="3nuphvak5c7gj">
                <Icon size={32} color="#7DC920" data-id="element-329" data-mp="3rvhsa74r8iee" />
                <p style={{
              fontSize: '15px',
              fontWeight: 600,
              color: '#1a1a1a',
              margin: '8px 0 4px'
            }} data-id="element-330" data-mp="3rwb43mikly3e">
                  {title}
                </p>
                <p style={{
              fontSize: '13px',
              color: '#666'
            }} data-id="element-331" data-mp="344vvxd444mk8">
                  {text}
                </p>
              </div>)}
          </div>
          <Link to="/#como-funciona" style={{
          color: '#7DC920',
          fontSize: '14px',
          fontWeight: 600,
          textAlign: 'center',
          display: 'block',
          marginTop: '24px',
          textDecoration: 'none'
        }} data-id="element-332" data-mp="31j4ylj4x7j7e">
            ¿Quieres saber exactamente cómo se procesa tu donación? Conoce el
            proceso →
          </Link>
        </div>
      </section>
    </main>;
}